import * as yup from "yup";

export const assetSchema = yup.object().shape({
  name: yup.string().required("Asset name is required"),
  type: yup.string().required("Asset type is required"),
  description: yup.string().notRequired().nullable(),
  quantity: yup.number().notRequired().min(0),
  acquisition_method: yup.string().required("Acquisition method is required"),
  acquisition_date: yup.date().notRequired().nullable(),
  purchase_price: yup.number().notRequired().min(0),
  vendor: yup.string().notRequired().nullable(),
  assigned_to: yup.string().notRequired().nullable(),
  depreciation_method: yup.string().notRequired().nullable(),
  location: yup.string().notRequired().nullable(),
  status: yup.string().required("Status is required"),
  condition: yup.string().required("Condition is required"),
  depreciation_rate: yup.number().notRequired().min(0),
  book_value: yup.number().notRequired().min(0),
  maintenance_schedule: yup.date().notRequired().nullable(),
  last_maintenance_date: yup.date().notRequired().nullable(),
  warranty_expiry_date: yup.date().notRequired().nullable(),
  documents: yup.string().notRequired().nullable(),
  compliance_status: yup.string().notRequired().nullable(),
  notes: yup.string().notRequired().nullable()
});
